import React from "react";
import ReactDOM from "react-dom/client";
import _ from "lodash";
import DateFormatter from "../../../../app/formatters/DateFormatter";
import CfcNoResult from "./CfcNoResult";

class CfcPlanning extends React.Component {
  /**
   * Creates an instance of GestiawebUpdates.
   * @param {Object} props - Propriétés
   */
  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      categories: [],
      cycles: [],
      wods: [],
      currentCategory: {
        cfc_wods: []
      },
      currentWod: {},
      currentCycles: []
    };
  }

  /**
   * Fonction spécifique à ReactJS pour charger le composant
   */
  componentDidMount() {
    fetch(`/cfc-cycle/__api/index/${this.state.id}`)
      .then(res => res.json())
      .then(result => {
        var currentCategory = result.categories[0],
          currentCycles,
          currentWod;

        currentWod = currentCategory.cfc_wods[0];
        currentCycles = _.filter(result.cycles, cycle => {
          return cycle.cfcCategoryId === currentCategory.id && cycle.cfcWodId === currentWod.id && currentWod.display_cycles;
        });

        this.setState({
          categories: result.categories,
          cycles: result.cycles,
          currentCategory,
          currentWod,
          currentCycles
        });
      });
  }

  /**
   * Permet de changer de catégorie
   * @param {Event} e - Evénement associé au change du select de la catégorie
   */
  changeCategory(e) {
    var id = parseInt(e.target.value, 10),
      currentCategory = _.find(this.state.categories, { id }),
      currentWod,
      currentCycles;

    currentWod = currentCategory.cfc_wods[0];
    currentCycles = _.filter(this.state.cycles, cycle => {
      return cycle.cfcCategoryId === currentCategory.id && cycle.cfcWodId === currentWod.id && currentWod.display_cycles;
    });

    this.setState({
      currentCategory,
      currentWod,
      currentCycles
    });
  }

  /**
   * Permet de changer de wod
   * @param {Event} e - Evénement associé au change du select du wod
   */
  changeWod(e) {
    var id = parseInt(e.target.value, 10),
      currentCategory = this.state.currentCategory,
      currentWod,
      currentCycles;

    currentWod = _.find(currentCategory.cfc_wods, { id });
    currentCycles = _.filter(this.state.cycles, cycle => {
      return cycle.cfcCategoryId === currentCategory.id && cycle.cfcWodId === currentWod.id && currentWod.display_cycles;
    });

    this.setState({
      currentWod,
      currentCycles
    });
  }

  formatTeamName(cycleUser) {
    if (cycleUser.cfc_registration.team_name) {
      return `Ligne n°${cycleUser.position}  : ${cycleUser.cfc_registration.team_name}`;
    } else {
      return `Ligne n°${cycleUser.position} : ${cycleUser.cfc_registration.user.firstname} ${cycleUser.cfc_registration.user.lastname}`;
    }
  }

  /**
   * Rendu du composant
   * @return {Object} Le noeud HTML à afficher dans la page
   */
  render() {
    return (
      <div>
        {this.state.currentCycles.length ? (
          <>
            <div className="flexline flexline--gap-8 flexline--no-mobile">
              <div className="input-group input-group--no-margin">
                <select className="input-group__input" onChange={this.changeCategory.bind(this)} value={this.state.currentCategory.id}>
                  {this.state.categories.map((category, index) => (
                    <option value={category.id} key={index}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group input-group--no-margin">
                <select className="input-group__input" onChange={this.changeWod.bind(this)} value={this.state.currentWod.id}>
                  {this.state.currentCategory.cfc_wods.map((wod, index) => (
                    <option value={wod.id} key={index}>
                      {wod.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="space--16" />
          </>
        ) : null}
        {this.state.currentCycles.length ? (
          <div className="mosaic">
            {this.state.currentCycles.map((cycle, index) => (
              <div className="mosaic__item" key={index}>
                <div className="mosaic__section">
                  <h4 className="mosaic__title">
                    Vague n°{cycle.position} - {this.state.currentWod.name} - {this.state.currentCategory.name}
                  </h4>
                  <div className="mosaic__sub-title">
                    Début le {DateFormatter.formatDate(this.state.currentWod.start_date, false, false, true)} à {cycle.start} - Fin à {cycle.end}
                  </div>
                  <div className="mosaic__badges mosaic__badges--grid">
                    {cycle.cfc_cycle_users.map(
                      (cycleUser, index) =>
                        cycleUser.cfc_registration && (
                          <span className="mosaic__badge mosaic__badge--small mosaic__badge--center" key={index}>
                            {this.formatTeamName(cycleUser)}
                          </span>
                        )
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <CfcNoResult title="Aucune vague trouvée" />
        )}
      </div>
    );
  }
}

var cfcPlanningNode = document.getElementById("cfc-planning");
if (cfcPlanningNode) {
  var root = ReactDOM.createRoot(cfcPlanningNode);
  root.render(<CfcPlanning id={cfcPlanningNode.getAttribute("data-id")} />);
}
